import axios, { type AxiosPromise } from 'axios';

const ERROR_CONNECTION_ABORTED = 'ECONNABORTED';

// For stubbing in tests
export function request(config: $TSFixMe): AxiosPromise {
  return axios(config);
}

/**
 *
 * @param {Error} error
 * @returns {boolean}
 */
export function isNetworkTimeoutError(error: $TSFixMe): boolean {
  return error.code === ERROR_CONNECTION_ABORTED;
}
